import React from 'react'
import { Tooltip } from 'components/Form'

const FluencyTooltip = () => {

    return (
        <Tooltip title={"נתונים עד כמה הקריאה היתה רצופה או מקוטעת"} />
    )
}

export default FluencyTooltip